import React, { Component } from 'react';
import { Modal, WhiteSpace, Button, Toast } from 'antd-mobile';
import * as services from '../../projects/services';
import { CommonlyHeadMembers } from '../../common/headnav';
import { AddAddress } from "../../common/addAddress";
import './style.less';
const alert = Modal.alert;
let firstshow = false;
export default class AddressList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal1: false,
            sexlist: [],
            marriagelist: [],
            peoplelist: [],
            Bagid: 0,
            Marital: 0,
            Fullname: '',
            Idnumber: '',
            Mobile: '',
            PeopleId: 0,
            add: [],
        }
    }
    componentDidMount() {
        firstshow = true;
        this.GetAddressList();
    }
    GetAddressList() {
       
        services.GetAddressList('').then(data => {
            if (data.status === 0) {             
                this.setState({ peoplelist: data.result });
            } else {
                Toast.offline(data.message);
            }
        });
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }
    onAdd = (e) => {
        this.setState({
            modal1: true, add: [],
        });
    }
    onEdit = (data) => {
        this.setState({ modal1: true, add: data });
    }
    open = () => {
        this.setState({
            modal1: true,
        });
    }
    AddOrder = () => {

    }
    onClose = () => {
        this.GetAddressList();
        this.setState({
            modal1: false,
        });
    }
    del = (key) => {
        // DelPeople
        services.DelAddress(key, '正在删除请稍后').then(data => {
            if (data.status === 0) {
                Toast.success(data.message,1);
                this.GetAddressList();
            } else {
                Toast.offline(data.message,1);
            }
        });
    }
    render() {
        const { peoplelist } = this.state;
        return <div className="peoplebox">
            <CommonlyHeadMembers barname={'地址管理'} />
            <div>
              
                    {
                        firstshow && peoplelist.length === 0 ? <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                            <p>您还没有添加地址信息</p>
                        </div> :
                            <div>
                                {
                                    peoplelist.map((data, index) => (
                                        <div key={'p' + index}>
                                            <WhiteSpace />
                                            <div className="peoplelist">
                                                <div className="prpole-info">
                                                    <div className="info"><span className="name">{data.consingee}</span><span className="idcard">{data.linktel}</span></div>
                                                    <div className="info"><span className="tel">{data.provincename}{data.cityname}{data.countyname}{data.adress}</span></div>
                                                </div>
                                                <div className="prpole-but">
                                                    <Button className="smallbut" size="small" inline
                                                        onClick={() => {
                                                            this.onEdit(data);
                                                        }
                                                        }
                                                    >编辑</Button><Button className="smallbut" size="small" inline
                                                        onClick={() =>
                                                            alert('删除提示', '确定删除该收货人' + data.consingee + '吗?', [
                                                                { text: '不删了', onPress: () => console.log('cancel') },
                                                                { text: '确定删除', onPress: () => this.del(data.addressid) },
                                                            ])
                                                        }
                                                    >删除</Button>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                            </div>

                    }              
            </div>
            <div className="footer">
                <div className="footerbox">
                    <Button className="inline-addbut" onClick={this.onAdd}>添加地址</Button>
                </div>
            </div>
            <Modal
                visible={this.state.modal1}
                transparent
                closable={true}
                maskClosable={true}
                onClose={this.onClose}
                wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            ><AddAddress onClose={this.onClose} data={this.state.add} />
            </Modal>
        </div>
    }
}